

















import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import CollectionAgingView from '../../../collections/sections/CollectionAgingView.vue'
import CollectionAgingTransaction from '../../../collections/components/CollectionAgingTransaction.vue'

@Component({
  components: { CollectionAgingView, Card, CollectionAgingTransaction }
})
export default class ResidentAgingTab extends Vue {
  tabs: any = [{
    name: 'Aging',
    component: CollectionAgingView
  }, {
    name: 'Transaction',
    component: CollectionAgingTransaction
  }];
  currentTab = this.tabs[0];

  get residentId () {
    return this.$route.params.id
  }
}
